<template>
  <div class="mine-page" v-loading="pageLoading">
    <!-- <van-nav-bar title="考试试卷" v-if="$until.myBrowser()=='Safari'" class="topTitle"/> -->
    <van-count-down :time="time" class="time" @finish="finish" v-if="type == 1 && timeStart" />
    <div class="numList" v-show="themeShow">
      <!-- <p @click="themeShow = false">关闭</p> -->
      <div class="list">
        <p class="item" :key="index" :class="{ blue: item && item.result }" v-for="(item, index) in resultList"
          @click="changeTitleIndex(index)">
          {{ index + 1 }}
        </p>
      </div>
    </div>
    <p class="titleBtn" v-if="!isReview" @click="themeShow = true">题目列表</p>
    <div class="examinList" :class="{ reviewBg: isReview }">
      <div class="process" v-if="!isReview">
        <p>已答题</p>
        <div class="gray">
          <p class="num">{{ finishList.length }}/{{ examinList.length }}</p>
          <p class="yellow" :style="{ width: (finishList.length / examinList.length) * 100 + '%' }"></p>
        </div>
        <div @click="submit" class="btn">交卷</div>
      </div>
      <div class="examin" v-if="examinList[currentIndex]">
        <div class="type">{{ examinList[currentIndex].type_name }}</div>
        <div class="examinTitle">
          {{ currentIndex + 1 }}.{{ examinList[currentIndex].title }}
        </div>
        <!-- 单选 判断-->
        <div class="answer" v-if="examinList[currentIndex].type_id == 1 || examinList[currentIndex].type_id == 3">
          <!-- ||(isReview && item.flag == list[currentIndex].result) -->
          <!-- is_correct 0是错误 1正确 2未提交过 -->
          <div :class="{
            err: isReview && list[currentIndex].result == item.flag && !list[currentIndex].status,
            checked:
              !isReview && item.flag == currentAnswer || isReview && item.flag == examinList[currentIndex].result,
          }" class="answerItem" v-for="(item, index) in answerList" @click="chooseAnswer(item)" :key="index">
            <img v-if="isReview && currentInfo.type_id == 1" :src="list[currentIndex].status && item.flag != currentAnswer || !list[currentIndex].status && item.flag != currentAnswer && item.flag != currentInfo.result ?
              check :
              list[currentIndex].status && item.flag == currentInfo.result || !list[currentIndex].status && item.flag == currentInfo.result ?
                checked : checkedRed
              " />
            <img v-if="isReview && currentInfo.type_id == 3" :src="item.flag != list[currentIndex].result
                ? check
                : !list[currentIndex].status
                  ? checkedRed
                  : checked
              " />

            <img v-if="!isReview"
              :src="currentAnswer == (currentInfo.type_id == 3 ? item.value : item.flag) ? checked : check" />
            {{ item.flag }}.{{ item.text }}
          </div>
        </div>
        <!-- 多选-->
        <div class="answer" v-if="examinList[currentIndex].type_id == 2">
          <!-- || (isReview && list[currentIndex].result.indexOf(item.flag) !=-1)  -->
          <div :class="{
            checked: !isReview && currentAnswer.indexOf(item.flag) != -1 || isReview && list[currentIndex].status && currentAnswer.indexOf(item.flag) != -1,
            err: isReview && !list[currentIndex].status && currentAnswer.indexOf(item.flag) != -1
          }" class="answerItem" v-for="(item, index) in answerList" @click="chooseAnswer2(item)" :key="index">
            <img v-if="!isReview" :src="currentAnswer.indexOf(item.flag) > -1 ? checked2 : check2" />
            <img v-if="isReview"
              :src="currentAnswer.indexOf(item.flag) == -1 ? check2 :
                list[currentIndex].status && list[currentIndex].result.indexOf(item.flag) > -1 ? checked2 : checkedRed2" />
            {{ item.flag }}.{{ item.text }}
          </div>
        </div>
        <!-- 填空 -->
        <div class="answer" v-if="examinList[currentIndex].type_id == 4">
          <!-- || (isReview && list[currentIndex].result.indexOf(item.flag) !=-1)  -->
          <div :class="{ err: isReview && item.text != JSON.parse(currentInfo.result)[index] }" class="answerItem"
            v-for="(item, index) in answerList" :key="index">{{ index + 1 }}、
            <input type="text" @input="changeAnswer(index, item)" class="inputText" v-model.trim="item.text" />
            <!-- <img v-if="!isReview" :src="currentAnswer.indexOf(item.flag) >-1 ? checked2 : check2"/>
            {{ item.flag }}.{{ item.text }} -->
          </div>
        </div>
        <!-- 解析 -->
        <div class="explain" v-if="isReview">
          <b>解析</b>
          <div class="rightAnswer">
            正确答案：<span>{{ currentInfo.type_id == 3 ? currentInfo.result == 1 ? 'A.对' : 'B.错' : currentInfo.result
              }}</span>
          </div>
          <p>{{ currentInfo.explain }}</p>
        </div>
      </div>
      <div class="changeBtn">
        <p class="btnP" v-show="currentIndex != 0" @click="changeTitle('pre')">上一题</p>
        <p class="btnP" v-show="currentIndex < examinList.length - 1" @click="changeTitle('next')">
          下一题
        </p>
        <!-- <p class="btnSubmit"  @click="submit" v-show="currentIndex == examinList.length - 1" v-if="!isReview">
          交卷
        </p> -->
      </div>
      <div v-if="isReview">
        <p class="close" @click="toResultDetail()">返回</p>
      </div>
    </div>
  </div>
</template>

<script>
import ExaminHeader from "@/components/ExaminHeader.vue";
import check from "./images/check.png"
import checked from "./images/checked.png"
import checkedRed from "./images/checkedRed.png"
import check2 from "./images/check2.png"
import checked2 from "./images/checked2.png"
import checkedRed2 from "./images/checkedRed2.png"
export default {
  components: { ExaminHeader },
  name: "examinList",
  data() {
    return {
      themeShow: false,
      type: 0,
      check,
      checked,
      checkedRed,
      check2,
      checked2,
      checkedRed2,
      time: 1000 * 60 * 60,
      pageLoading: false,
      isReview: true,
      currentIndex: -1,
      currentAnswer: "",
      list: [],
      timeStart: false,
      examinList: [
        {
          name: "1育婴员在工作过程中应该遵循哪些原则？",
          chooseAnswer: 1,
          answer: 1,
          id: 1,
          type_id: 2,
          options: '',
        },
        {
          name: "2育婴员在工作过程中应该遵循哪些原则？",
          chooseAnswer: 1,
          answer: 2,
          id: 2,
        },
        {
          name: "3育婴员在工作过程中应该遵循哪些原则？",
          chooseAnswer: 1,
          answer: 3,
          id: 3,
          uid: '',
        },
      ],
      report_id: '',
      uid2: '',
      resultList: [],
      answerList: [],
      answerObject: [],
      err:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E5%85%B3%E9%97%AD%20(1).png",
      right:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E5%AF%B9%E5%8F%B7%20(1)%E5%A4%87%E4%BB%BD.png",
    };

  },
  async mounted() {
    this.id = this.$route.query.id;
    this.isReview = this.$route.query.isExamin ? false : true
    // this.type = this.$route.query.type
    document.title = this.isReview ? "答题详情" : "考试试卷"
    this.examinList = []

    this.getData();
  },
  computed: {
    plat() {
      return this.$store.state.plat_id
    },
    currentInfo() {
      return this.currentIndex > -1 ? this.examinList[this.currentIndex] : {}
    },
    finishList() {
      return this.resultList.filter(item => item && item.result)
    },
  },
  watch: {
    currentIndex() {
      if (this.isReview) {
        this.currentAnswer = this.list[this.currentIndex].result
      } else {
        this.currentAnswer = this.resultList[this.currentIndex] && this.resultList[this.currentIndex].result ? this.resultList[this.currentIndex].result : ''
      }
      if (this.examinList[this.currentIndex].type_id == 4) { //填空
        this.answerList = this.currentAnswer ? JSON.parse(this.currentAnswer).map(item => {
          let v = { 'text': item }
          return v
        }) : new Array(this.currentInfo.number).fill({ text: '' })
        this.answerObject = JSON.parse(JSON.stringify(this.answerList))
      } else if (this.examinList[this.currentIndex].type_id == 3) {
        this.answerList = [
          {
            flag: "1",
            value: 1,
            text: "对",
          },
          {
            flag: "2",
            text: "错",
            value: 2,
          },
        ];
      } else {
        this.answerList = this.examinList[this.currentIndex].options
          ? JSON.parse(this.examinList[this.currentIndex].options)
          : [];
      }
    },
  },
  methods: {
    changeTitleIndex(index) {
      this.currentIndex = index
      this.themeShow = false
    },
    toResultDetail() {
      this.$router.replace({
        path: './examinResultDetail',
        query: {
          id: this.$route.query.resultId,
          examinId: this.$route.query.id,
          isReview: true
        }
      })
    },
    // 交卷
    submit() {
      if (this.finishList.length < this.examinList.length) {
        this.$toast('题目未全部完成')
        return
      }
      this.$dialog.confirm({
        title: '标题',
        message: '确定交卷？',
      })
        .then(() => {
          this.pageLoading = true;
          let time = (new Date().getTime() - this.timeStart.getTime()) / 1000
          this.$api({
            method: "post",
            url: "/api/goods/test/answer",
            data: {
              test_id: this.id,
              duration: time,
              answer: JSON.stringify(this.resultList),
              discipline_id: this.$route.query.discipline_id
            },
          }).then(res => {
            this.pageLoading = false;
            if (res.code == 0) {
              this.$toast('提交成功')
              setTimeout(() => {
                this.$router.replace({
                  path: './examinResult',
                  query: {
                    id: res.data.id,
                    isPass: res.data.is_pass,
                    examinId: this.id
                  }
                })
              }, 1500)
            } else {
              this.$toast(res.msg);
            }

          })

        })
        .catch(() => {
          // on cancel
        });

    },
    // 切换题目
    changeTitle(type) {

      if (!this.isExamin) {
        this.currentIndex = type == 'pre' ? this.currentIndex - 1 : this.currentIndex + 1

        return
      }
      if (!this.currentAnswer) {
        this.$toast('请选择答案')
        return
      }


      this.currentIndex = type == 'pre' ? this.currentIndex - 1 : this.currentIndex + 1

      this.currentAnswer = this.resultList[this.currentIndex] ? this.resultList[this.currentIndex].result : ''


    },

    // 填空
    changeAnswer(index, item) {
      if (!this.isExamin) {
        return
      }
      this.answerObject[index] = item
      this.answerList = JSON.parse(JSON.stringify(this.answerObject))
      if (this.answerList.findIndex(item => item.text) != -1) {
        this.currentAnswer = JSON.stringify(this.answerList.map(item => item.text))
      } else {
        this.currentAnswer = ''
      }

      let myAnswer = {
        result: this.currentAnswer,
        question_id: this.examinList[this.currentIndex].question_id,
        score: this.examinList[this.currentIndex].score,
      };
      // if (this.resultList[this.currentIndex]) {
      //   this.$set(this.resultList, this.currentIndex, myAnswer)
      // } else {
      //   this.resultList.push(myAnswer);
      // }
      this.$set(this.resultList, this.currentIndex, myAnswer)

    },
    // 单选选择答案
    chooseAnswer(item) {
      if (this.isReview) {
        return;
      }
      this.currentAnswer = item.flag;
      let myAnswer = {
        result: this.currentAnswer,
        question_id: this.examinList[this.currentIndex].question_id,
        score: this.examinList[this.currentIndex].score,
      };

      // this.resultList[this.currentIndex] = myAnswer
      this.$set(this.resultList, this.currentIndex, myAnswer)
    },
    // 多选选择答案
    chooseAnswer2(item) {
      if (this.isReview) {
        return
      }
      let answerArr = this.currentAnswer ? this.currentAnswer.split(",") : [];

      let index = answerArr.findIndex((v) => v == item.flag);
      if (index == -1) {
        answerArr.push(item.flag);
      } else {
        answerArr.splice(index, 1);
      }
      this.currentAnswer = answerArr.sort().join(",");

      let myAnswer = {
        result: this.currentAnswer,
        question_id: this.examinList[this.currentIndex].question_id,
        score: this.examinList[this.currentIndex].score,
      };
      // this.resultList[this.currentIndex] = myAnswer
      this.$set(this.resultList, this.currentIndex, myAnswer)
    },
    toExamin() {
      this.$router.push({
        path: './examinList',
        query: {

        }
      })
    },
    async getData() {
      this.pageLoading = true;
      let res = await this.$api({
        method: "get",
        url: "/api/flat/test/index",
        data: {
          test_id: this.id,
        },
      });
      if (!this.isExamin) {
        let res2 = await this.$api({
          method: "get",
          url: "/api/flat/test/detail",
          data: {
            test_report_id: this.$route.query.resultId,
          },
        });
        if (res2.code == 0) {
          this.list = res2.data.list;
        } else {
          this.$toast(res2.msg);
        }
      }
      this.pageLoading = false;
      if (res.code == 0) {
        this.examinList = res.data.list;
        this.resultList = new Array(this.examinList.length).fill(null)
        this.currentIndex = this.$route.query.currentIndex * 1 || 0
        this.timeStart = new Date()
      } else {
        this.$toast(res.msg);
      }
    },
    jumpDetail(item) {
      this.$router.push(`./detail?id=${item.id}`)
    },

  },
  beforeRouteUpdate(to, from, next) {
    next()
  },
};
</script>

<style lang="scss" scoped>
.numList {
  position: fixed;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  background-color: #fff;

  .list {
    flex: 1;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    padding: 40px 0;
  }

  .list .item {
    float: left;
    width: 12vw;
    height: 12vw;
    border: 1px solid #979797;
    text-align: center;
    line-height: 12vw;
    border-radius: 50%;
    margin: 0 2vw 4vw;
    font-size: 36px;
    box-sizing: border-box;
    color: #56586A;
  }

  .list .item:nth-child(6n+1) {
    margin-left: 4vw;
  }

  .list .item:nth-child(6n+6) {
    margin-right: 4vw;
  }

  .list .red {
    background: #FFE7E7;
    border-color: #FFE7E7;
    color: #D02E2E;
  }

  .list .blue {
    background: #E7EFFF;
    border-color: #E7EFFF;
    color: #2E66D0;
  }
}

.mine-page {
  background: #fff url("./images/bg.png");
  background-size: contain;
  background-position: top;
  background-repeat: no-repeat;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
}

.time {
  position: fixed;
  top: 30px;
  right: 20px;
  color: #fff;
}

.titleBtn {
  position: fixed;
  top: 30px;
  right: 20px;
  font-size: 24px;
  padding: 10px;
  background: #fff;
  color: #2E66D0;
  border-radius: 2px;
}

.examinList {
  flex: 1;
  width: 100vw;
  border-radius: 40px 40px 0px 0px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.reviewBg {
  border-radius: 0;
}

.examinList .process {
  margin-top: 249px;
  background: url("./images/processBg.png") top no-repeat;
  width: 100%;
  background-size: 100%;
  color: #2E66D0;
  font-size: 28px;
  display: flex;
  align-items: center;
  font-weight: 500;
  height: 108px;
  padding: 0 40px;
}

.examinList .process .btn {
  color: #333;
  font-size: 32px;
  padding-left: 45px;
}

.examinList .process .gray {
  flex: 1;
  position: relative;
  color: #ffffff;
  height: 24px;
  border-radius: 12px;
  background: rgba(147, 149, 158, 0.1);
  margin-left: 20px;
}

.examinList .process .gray .yellow {
  position: absolute;
  height: 100%;
  border-radius: 12px;
  left: 0;
  top: 0;
  background-color: #2E66D0;
}

.examinList .process .gray .num {
  position: absolute;
  z-index: 10;
  left: 5px;
  top: 0;
  line-height: 24px;
}

.examin {
  background: #fff;
  padding: 30px 40px;
  flex: 1;
  overflow: auto;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;

  .type {
    display: inline-block;
    height: 61px;
    line-height: 61px;
    background: #2E66D0;
    border-radius: 8px;
    padding: 0 20px;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    margin-bottom: 40px;
  }
}

.examin .examinTitle {
  font-size: 36px;
  font-weight: 500;
  color: #333333;
  line-height: 50px;
  margin-bottom: 50px;
}

.examin .answerItem {
  width: 100%;
  line-height: 45px;
  border-radius: 49px;
  font-size: 32px;
  margin-bottom: 40px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  img {
    width: 38px;
    margin-right: 16px;
  }
}

.examin .answerItem .right {
  width: 37px;
  height: 25px;
}

.examin .answerItem .err {
  width: 24px;
  height: 24px;
}

.inputText {
  width: 680px;
  height: 94px;
  border-radius: 16px;
  border: 2px solid #E1E1E1;
  text-indent: 10px;
}

.examin .checked {
  color: #2E66D0;
}

.examin .err {
  color: #E9313F;

  input {
    border-color: #E9313F;
  }

  // background: #ff5f6e;
}

.explain {
  b {
    font-size: 30px;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
    display: block;
    margin-bottom: 33px;
  }

  .rightAnswer {
    width: 100%;
    height: 75px;
    background: #F1F5FB;
    border-radius: 8px;
    line-height: 75px;
    font-size: 30px;
    font-weight: 500;
    color: #333333;
    padding-left: 19px;
    box-sizing: border-box;
    margin-bottom: 56px;

    span {
      color: #2E66D0;
    }
  }

  p {
    font-size: 34px;
    font-weight: 400;
    color: #333333;
    line-height: 51px;
  }
}

.changeBtn {
  width: 100vw;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 50px;
}

.changeBtn .btnP {
  width: 332px;
  height: 90px;
  border-radius: 16px;
  border: 2px solid #2E66D0;
  font-size: 34px;
  font-weight: 500;
  color: #2E66D0;
  line-height: 90px;
  text-align: center;
  margin: 0 14px;
}

.changeBtn .btnSubmit {
  width: 332px;
  height: 90prx;
  border-radius: 44px;
  border: 2px solid #268893;
  text-align: center;
  line-height: 90px;
  font-size: 34px;
  background-color: #268893;
  color: #fff;
}

.close {
  width: 460px;
  height: 104px;
  background: #2E66D0;
  border-radius: 16px;
  text-align: center;
  line-height: 104px;
  margin: 0 auto 60px;
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
}
</style>

<style lang="scss"></style>
